<template>
  <v-container fluid>
    <v-card>
      <v-container fluid>
        <v-row v-if="images.length > 0">
          <v-col
            v-for="(image,index) in images"
            :key="image.id || index"
            class="d-flex child-flex"
            cols="4"
            md="2"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card flat tile class="relative">
                <span class="z-index-5 absolute" v-if="image.is_default">
                  <v-icon size="32" @click="toggleImageDefault(image)" color="primary">mdi-star</v-icon>
                </span>
                <span class="z-index-5 absolute" v-else-if="hover">
                  <v-icon
                    size="27"
                    @click="toggleImageDefault(image)"
                    color="primary"
                  >mdi-star-outline</v-icon>
                </span>
                <v-img
                  contain
                  :src="image.image_url"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  @click="showPicture(index)"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row v-else justify="center">
          <v-col cols="12" md="12">
            <p
              class="subtitle-1 font-weight-medium grey--text text--darken-2 pa-0 ma-0 text-center"
            >Store images will appear here. No images created yet.</p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-overlay @keydown.esc="overlay = false" opacity="0.85" :value="overlay" z-index="100">
      <v-layout row wrap>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="deleteImage(images[overlayImageIndex], overlayImageIndex)"
              absolute
              left
              icon
              top
              color="white"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>Delete Image</span>
        </v-tooltip>
        <v-btn @click="overlay = false" absolute right icon top color="white">
          <v-icon>close</v-icon>
        </v-btn>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click="toggleImageDefault(images[overlayImageIndex])"
              absolute
              left
              icon
              bottom
              color="white"
            >
              <v-icon v-if="!images[overlayImageIndex].is_default">mdi-star-outline</v-icon>
              <v-icon v-else>mdi-star</v-icon>
            </v-btn>
          </template>
          <span>Default Location Image</span>
        </v-tooltip>
      </v-layout>
      <v-row justify="center" align="center">
        <v-col cols="1" md="2" class="text-right">
          <v-btn icon color @click="previousImage">
            <v-icon>arrow_left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10" md="8" v-if="images.length > 0">
          <v-img
            :src="images[overlayImageIndex].image_url"
            contain
            aspect-ratio="1.6"
            width="100vw"
            height="90vh"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-layout row wrap justify-center>
            <p>{{overlayImageIndex+1}}/{{images.length}}</p>
          </v-layout>
        </v-col>
        <v-col cols="1" md="2" class="text-left">
          <v-btn icon color @click="nextImage">
            <v-icon>arrow_right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-overlay>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          @click="$root.resourcePicker.status = true"
          fab
          fixed
          dark
          bottom
          right
          color="primary"
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Create Location</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  mounted() {
    this.getLocationImages()
    this.$root.$on('resource-selected', (event) => {
      this.addImageToLocation(event[0].full_url)
    })
  },
  data() {
    return {
      overlay: false,
      overlayImageIndex: 0,
      images: []
    }
  },
  methods: {
    showPicture(index) {
      this.overlayImageIndex = index
      this.overlay = true
    },
    async getLocationImages() {
      let response
      try {
        response = await LocationAPI.getLocationImages({ locationId: this.$route.params.id })
      } catch (error) {
        this.images = []
        return console.log(error)
      }
      this.images = response.data.payload
    },
    async addImageToLocation(imageUrl) {
      let data = {
        'location_id': this.$route.params.id,
        'image_url': imageUrl,
        'is_default': false
      }
      let response
      try {
        response = await LocationAPI.addLocationImage({ data })
      } catch (error) {
        return console.log(error)
      }
      this.images.push(response.data.payload)
      this.swal({ title: 'Success', text: 'Image added successfully', timer: 3000 })
    },
    nextImage() {
      if (this.overlayImageIndex < this.images.length - 1) {
        this.overlayImageIndex++
      } else {
        this.overlayImageIndex = 0
      }
    },
    previousImage() {
      if (this.overlayImageIndex > 0) {
        this.overlayImageIndex--
      } else {
        this.overlayImageIndex = this.images.length - 1
      }
    },
    async toggleImageDefault(image) {
      let data = {
        is_default: !image.is_default
      }
      try {
        await LocationAPI.updateLocationImage(image.id, data)
      } catch (error) {
        return console.log(error)
      }
      image.is_default = !image.is_default
      if (image.is_default) {
        this.snackbar({ text: 'Default image selected', color: 'success', icon: 'check' })
      } else {
        this.snackbar({ text: 'Default image removed.', color: 'warning darken-1' })
      }
    },
    async deleteImage(image, index) {
      let response
      try {
        await LocationAPI.deleteLocationImage({ id: image.id })
      } catch (error) {
        return console.log(image)
      }
      if (this.overlayImageIndex === 0) {
        if(this.images.length > 2) {
          this.overlayImageIndex++
        } else {
          this.overlayImageIndex = 0
        }
      } else if (this.overlayImageIndex < this.images.length) {
        this.overlayImageIndex--
      }
      this.images.splice(index, 1)
      if (this.images.length <= 0) {
        this.overlay = false
      }
      this.swal({ title: 'Success', text: 'Image deleted successfully', timer: 3000 })
    }
  }

}
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
}
.absolute {
  position: absolute;
  top: 0;
  right: 0;
}

.z-index-5 {
  z-index: 5;
}
</style>
